import countBy from 'lodash/countBy';
import maxBy from 'lodash/maxBy';
import toPairs from 'lodash/toPairs';
import last from 'lodash/last';
import head from 'lodash/head';

/**
 * Returns a displayable string for a complex value selection.
 *
 * This simply grabs the most common labels and returns the one
 * with the highest score.
 *
 * @param {Array} val
 * @return {string|null}
 */
export default (val: unknown[] | unknown): unknown => {
  if (!Array.isArray(val)) {
    return val;
  }

  if (val.length === 0) {
    return null;
  }

  // Based on https://stackoverflow.com/a/18878650/1397894
  const scores = countBy(val, 'value');
  const sorted = maxBy(toPairs(scores), last);

  return head(sorted);
};
